const configCompetition = {
    competition: {
        listLayout: 'CompetitionListDefaultLayout',
        filterLayout: 'CompetitionFilterDefaultLayout',
        paginationLayout: 'PaginationDefaultLayout',
        getFunc: 'getCompetition',
        listApiParamSet: {
            ip: 1,
            page: 1,
            sp: 10,
            obt: 'created_at',
            obs: 'desc',
        },
        sortOptions: {
            keyName: 'obt',
            orderName: 'obs',
        },
        pageRow: 10,
    },
    userCompetition: {
        listLayout: 'CompetitionListUserLayout',
        filterLayout: 'CompetitionFilterUserLayout',
        paginationLayout: 'PaginationDefaultLayout',
        getFunc: 'getCompetition',
        listApiParamSet: {
            ip: 1,
            sp: 1,
            page: 1,
            obt: 'created_at',
            obs: 'desc',
        },
        keyName: 'no',
        pageRow: 10,
    },
    detail: {
        writeLayouts: ['CompetitionWriteDefaultLayout'],
        getFunc: 'getCompetitionDetail',
        detailApiParamsSet: {
            ip: 0,
        },
        writeFunc: 'updateCompetition',
        keyName:'uid',
        writeApiParamSet: {},
        parsingData: {
            title: 'c_title',
            category: 'ic_idx',
            hashtag: 'hashtag',
            organize: 'c_organize',
            target: 'c_target',
            content: 'c_context',
            license: 'c_license',
            evaluate: 'evaluate',
            is_judge: 'c_is_judge',
            u_judge: 'judge',
            prize: 'c_prize',
            startApplyDate: 'c_start_time',
            endApplyDate: 'c_end_time',
            releaseDate: 'c_release_time',
            chance: 'c_apply_cnt',

        },
        fileInfo: [
            //fileName : front에서 정한 파일 이름 ,
            //fileType : api에 전송하는 a_container_type 이름
            {
                fileName: 'poster',
                fileType: 'contestPoster',
            },
            {
                fileName: 'intro',
                fileType: 'contestIntro',
            },
        ],
        writeSuccessType: 1,
        writeValidatorArr: [
            'title',
            'category',
            'hashtag',
            'organize',
            'target',
            'content',
            'license',
            'evaluate',
            'is_judge',
            'prize',
            'startApplyDate',
            'endApplyDate',
            'releaseDate',
            'chance',
            'poster',
            'intro',
        ],
        writeFailTypes: {
            '-100': '필수값이 없습니다.',
            '-103' : '객체가 없습니다.',
            '-801' : '1차 카테고리가 일치하지 않습니다.',
            '-831' : '서브 카테고리가 일치하지 않습니다.',
            '-811': '올바른 심사위원이 아닙니다.',
            '-812' : '심사위원 수를 초과했습니다.',
        },
        deleteFunc: 'deleteCompetition',
        deleteApiParamSet: {},
        deleteSuccessType: 1,
        deleteErrorTypes: {
            '-202': "삭제 권한이 없습니다.",
            '-802' : "삭제가 불가능한 상태입니다."
        },
        deleteKayName : 'c_idx',
    },
    entry: {
        listLayout: 'CompetitionListEntryLayout',
        emptyLayout: 'CompetitionEmptyDefaultLayout',
        filterLayout: 'CompetitionFilterEntryLayout',
        paginationLayout: 'PaginationDefaultLayout',
        getFunc: 'getCompetitionItem',
        listApiParamSet: {
            ip: 1,
            page: 1,
            sp: 10,
            obt: 'created_at',
            obs: 'desc',
        },
        keyName:'cuid',
        sortOptions: {
            keyName: 'obt',
            orderName: 'obs',
        },
        pageRow: 10,
    },
    award: {
        listLayout: 'CompetitionListAwardLayout',
        filterLayout: 'CompetitionFilterNoneLayout',
        paginationLayout: 'PaginationDefaultLayout',
        getFunc: 'getAward',
        listApiParamSet: {
            ip: 1,
            page: 1,
            sp: 10,
            obt: 'created_at',
            obs: 'desc',
        },
        sortOptions: {
            keyName: 'obt',
            orderName: 'obs',
        },
        keyName:'cuid',
        pageRow: 10,
    },

}
import util from "@/mixins/util";

export default {
    methods: {
        returnCompetitionConfig(type) {
            return configCompetition[type];
        },

    },
    filterConfig: {
        cr: {
            type: 'between',
            classname: 'filterDate'
        },
        al: {
            type: 'between',
            classname: 'filterDate'
        },
        out: {
            type: 'between',
            classname: 'filterOutDate'
        },
        ni: {
            type: 'query',
            classname: 'searchInput',
        },
        mid: {
            type: 'query',
            classname: 'searchInput',
        },
        bid: {
            type: 'query',
            classname: 'filterStatus',
        },
        bl: {
            type: 'match',
            classname: 'filterStatus',
        },
        cmty:{
            type: 'terms',
            classname: 'filterType',
        },
        //상태
        st :{
            type:'terms',
            classname : 'filterStatus'
        },
        icid :{
            type:'terms',
            classname : 'filterCategory'
        },
        ccid :{
            type:'terms',
            classname : 'filterCategory'
        },
        ti: {
            type: 'query',
            classname: 'searchInput',
        },
        pr:{
            type: 'between',
            classname: 'filterPrice',
            option:{
                start: 'prgt',
                end: 'prle'
            }
        },
        na: {
            type: 'query',
            classname: 'searchInput',
        },

    }
}
